
import React, {createRef} from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto} from "../Configuracion";
import PropTypes from "prop-types";
import Titulo from "../../framework2/ej2/UI/Titulo";
import SignaturePad from 'signature_pad';
import {getValorCampo, onKeyDown, showCampo, showComponente} from "../utils/FormularioUtils";

class ConsentimientoTexto extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            cargandoDatos: false,
            fecha: (new Date()).toLocaleString(),
            esMenorDeEdad: false,
            tutorNombre: "",
            tutorDni: "",
        }


    }

    /*
    getFechaActual= () => {
        const ahora = new Date();
        const fechaHora = ahora.toLocaleString();
        return fechaHora
    }
     */

    componentDidMount() {

    }


    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onCancelar= () => {
        const {onCancelar} = this.props;
        onCancelar && onCancelar();
    }

    onAceptar= () => {
        const {onAceptar} = this.props;
        onAceptar && onAceptar();
    }


    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------


    render() {
        const {consentimientoTextoHTML} = this.props;
        console.log ("consentimientoTextoHTML: ", consentimientoTextoHTML);
        return (
            <div style={{margin: 8, padding: 4}}>
                <div style={{ flex: 1, border: "1px solid #ccc", padding: "10px" }}>
                    <h2>Vista previa</h2>
                    <div
                        dangerouslySetInnerHTML={{ __html: consentimientoTextoHTML }}
                    />
                </div>

                <div style={{ marginTop: 10 }}>
                    <button onClick={this.onCancelar}>Cancelar</button>
                    <button onClick={this.onAceptar} style={{ marginLeft: 10 }}>Aceptar</button>
                </div>

            </div>
        )
    }

}

ConsentimientoTexto.propTypes = {
    consentimientoTextoHTML: PropTypes.string,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(ConsentimientoTexto);



